import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path d="M10.2896 9.77778L12.0673 0L0 14.2222H6.68013L4.30976 24L17.2391 9.77778H10.2896Z" fill="#B04DE7" />,
  'Lightning',
)
